<template>
  <svg
    class="checkmark"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52">
    <path v-if="value === 0" class="required" fill="none" d="M 17,17 L 35,35 M 35,17 L 17,35"/>
    <circle v-else-if="value === 10" class="partial" fill="none" cx="26" cy="26" r="12"/>
    <path v-else-if="value === 20" class="complete" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
    <path v-else-if="value === 99" class="not-required" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
  </svg>
</template>

<script>

export default {
  name: 'SvgMark',
  props: ['value'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.checkmark {
  width: 40px;
  height: 40px;
  display: block;
  stroke-width: 4;
  stroke: #000;
  display: inline-flex;
}

.required {
  stroke: #ff3860;
}

.partial {
  fill: #ffdd56;
  stroke-width: 0;
}

.complete {
  stroke: #20d260;
}

.not-required {
  stroke: black;
}
</style>
